/* Copyright (c) 2020-present CloudIO Inc */

import { Margin, Padding, Border } from 'componentregistry';
import { CSSProperties, useMemo } from 'react';
import useMargin from './useMargin';
import usePadding from './usePadding';
import useBorder from './useBorder';

function useMarginPadding(margin?: Margin, padding?: Padding): CSSProperties {
  const marginStyles = useMargin(margin);
  const paddingStyles = usePadding(padding);
  return useMemo(() => {
    return { ...marginStyles, ...paddingStyles };
  }, [marginStyles, paddingStyles]);
}

function useMarginPaddingBorder(
  margin?: Margin,
  padding?: Padding,
  border?: Border,
): CSSProperties {
  const marginStyles = useMargin(margin);
  const paddingStyles = usePadding(padding);
  const borderStyles = useBorder(border);
  return useMemo(() => {
    return { ...marginStyles, ...paddingStyles, ...borderStyles };
  }, [marginStyles, paddingStyles, borderStyles]);
}

function usePaddingBorder(padding?: Padding, border?: Border): CSSProperties {
  const paddingStyles = usePadding(padding);
  const borderStyles = useBorder(border);
  return useMemo(() => {
    return { ...paddingStyles, ...borderStyles };
  }, [paddingStyles, borderStyles]);
}

export {
  useBorder,
  useMargin,
  useMarginPadding,
  useMarginPaddingBorder,
  usePadding,
  usePaddingBorder,
};
